import { _initialState } from './_initialState';
import {
  updateCollection,
  updateSkus
} from './actions';

export const collectionStore = (set, get) => ({
  ..._initialState,
  updateCollection: (data) => updateCollection(set, get, data),
  updateSkus: (products, domensions) => updateSkus(set, products, domensions)
});
